'use client';

import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { curatorQueries } from '../../query-factory';

/**
 * 큐레이터 메인(활동내역) 데이터 재검증 — 렌더 출력 없음(부수효과 전용).
 *
 * 메인 데이터(`curatorQueries.mypage.data`)는 staleTime 60s + refetchOnWindowFocus:false 라,
 * 29CM 인앱에서 하위 화면(예: 이번 달 예상 수익)을 새 웹뷰로 다녀와 메인이 다시 보일 때
 * stale 캐시가 남아 "시딩 캠페인 참여하기" 개수가 갱신되지 않았다. 문서가 다시 visible 이 되는
 * 시점(웹뷰 복귀·탭 전환)에 invalidate 해 복귀 시마다 최신값을 노출한다. (CMQA-7172)
 *
 * me 메인 페이지에서 1회 마운트한다. invalidate 는 active query 를 즉시 refetch 하므로 staleTime
 * 과 무관하게 갱신된다. (data 쿼리는 예상 수익·판매 랭킹 등 메인 섹션이 공유 → 함께 갱신)
 */
export const MyPageDataRevalidator = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        queryClient.invalidateQueries({ queryKey: curatorQueries.mypage.data().queryKey });
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [queryClient]);

  return null;
};
